"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/nextjs";
import { designTokens } from "@/lib/designTokens";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          fontFamily: "'Segoe UI', system-ui, sans-serif",
          background: designTokens.bgPage,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", padding: 24 }}>
          <div style={{ textAlign: "center", maxWidth: 420 }}>
            <h2 style={{ fontSize: 18, fontWeight: 600, marginBottom: 8, color: designTokens.textPrimary }}>
              Something went wrong
            </h2>
            <p style={{ fontSize: 13, color: designTokens.textMuted, marginBottom: 16 }}>
              A critical error occurred. This has been reported automatically.
            </p>
            {error.digest && (
              <p style={{ fontSize: 11, color: designTokens.textMuted, fontFamily: "ui-monospace, monospace", marginBottom: 16 }}>
                Error ID: {error.digest}
              </p>
            )}
            <button
              type="button"
              onClick={reset}
              style={{
                padding: "8px 16px",
                fontSize: 13,
                fontWeight: 500,
                background: designTokens.blue,
                color: designTokens.white,
                border: "none",
                borderRadius: 8,
                cursor: "pointer",
              }}
            >
              Try again
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
